// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9e1425b4d3--wrapper--WSTpX","author":"_9e1425b4d3--author--Y0aiF","best-advice":"_9e1425b4d3--best-advice--zi0pX"};